import { MenuItem, Select } from "@material-ui/core";

const ItemSelectField = (props) => {
  const { value, onChange, items = [] } = props;
  return (
    <Select
      id="issue-filter-status"
      onChange={(e) => onChange(e)}
      value={value}
    >
      {items.map((item, index) => (
        <MenuItem key={index} value={item.id}>
          {item.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ItemSelectField;
